module.exports = __webpack_public_path__ + "7cedf07beb7e9554cccabf63db00aee3.pdf";